/**
 * Bedragen: op de draad een string met twee decimalen (`"1450.00"`) of `null`,
 * in de app hele centen, op het scherm `€ 1.450`.
 */

/**
 * Leest `"€ 1.450"`, `"1450"`, `"1.450,50"` en `"1450,50"` als 145000 / 145050
 * centen. Levert `null` bij een leeg of onleesbaar veld.
 */
export function parseEuroToCents(input: string): number | null {
    const cleaned = input.replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}\b)/g, '');
    const normalised = cleaned.replace(',', '.');

    if (normalised.trim() === '') {
        return null;
    }

    const value = Number(normalised);

    return Number.isFinite(value) ? Math.round(value * 100) : null;
}

/** `145000` → `"1450.00"`. */
export function centsToAmount(cents: number | null): string | null {
    return cents === null ? null : (cents / 100).toFixed(2);
}

/** `"1450.00"` → `145000`; `null` en onzin blijven `null` (zoals `Amount::toCents`). */
export function amountToCents(amount: string | null | undefined): number | null {
    if (amount === null || amount === undefined || amount.trim() === '') {
        return null;
    }

    const value = Number(amount);

    return Number.isFinite(value) ? Math.round(value * 100) : null;
}
